import React from 'react';
import { colors } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import GlobeIllustration from 'svg/illustrations/Globe';

const Benefits = () => {
  const sections = [
    {
      title: 'Transformación personal',
      subtitle: 'Historias y herramientas para moverse de la intención a la acción.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
      color: colors.orange,
    },
    {
      title: 'Autoconocimiento',
      subtitle: 'Reflexión, propósito y recursos para entender mejor quién eres y qué necesitas.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      color: colors.purple,
    },
    {
      title: 'Bienestar emocional',
      subtitle: 'Espacio para hablar de lo que importa con honestidad y sin tabúes.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      color: colors.pink,
    },
    {
      title: 'Relaciones y vínculos',
      subtitle: 'Familia, pareja, amistad y dinámicas que marcan nuestra calidad de vida.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      color: colors.red,
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color={'primary'}
          align={'center'}
        >
          Temas
        </Typography>
        <Box
          component={Typography}
          sx={{ fontWeight: 700 }}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={'primary'}
        >
          Un panorama para marcas con alma
        </Box>
        <Typography align={'center'} color="textSecondary" variant={'h6'}>
          3 de Copas organiza la conversación en ejes que la audiencia ya busca: crecimiento, autoconocimiento, emoción y vínculos. Cada eje es una puerta para que tu mensaje encaje con contexto, no con ruido.
        </Typography>
      </Box>
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        marginBottom={4}
        data-aos={'fade-up'}
      >
        <Box maxWidth={300} width={'100%'}>
          <GlobeIllustration width={'100%'} height={'100%'} />
        </Box>
      </Box>
      <Grid container spacing={4}>
        {sections.map((item, i) => (
          <Grid item xs={12} md={6} key={i}>
            <Box
              height={1}
              display={'flex'}
              flexDirection={'column'}
              data-aos={'fade-up'}
              data-aos-delay={i * 100}
            >
              <Box
                display={'flex'}
                justifyContent={'flex-start'}
                alignItems={'center'}
                marginBottom={2}
              >
                <Box
                  component={Avatar}
                  width={60}
                  height={60}
                  marginRight={2}
                  bgcolor={item.color[50]}
                  color={item.color[900]}
                >
                  {item.icon}
                </Box>
                <Box>
                  <Typography
                    variant={'h6'}
                    gutterBottom
                    sx={{ fontWeight: 700 }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              </Box>
              <Typography color="textSecondary">{item.subtitle}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

Benefits.propTypes = {};

export default Benefits;
